<template>
  <v-app
    id="materialpro"
    :class="`${
      !$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'
    }`"
  >
    <div v-for="(item, index) in site_themes" :key="index">
      <FallingSnowTheme v-if="item.type == 'falling_snow'" />
      <FallingHeartTheme v-if="false" />
    </div>

    <router-view v-show="!overlayLoading" />
    <div class="text-center">
      <v-overlay :z-index="zIndex" :value="overlayLoading" opacity="0.9">
        <v-progress-circular
          indeterminate
          size="64"
          :color="site.color"
        ></v-progress-circular>
        <h2 class="mt-5">{{ $t("waitingLoad") }}...</h2>
      </v-overlay>
    </div>

    <v-overlay :z-index="999" :value="isLoading" opacity="0.5">
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
        "
      >
        <v-progress-circular
          indeterminate
          size="64"
          :color="site.color"
        ></v-progress-circular>
        <span
          v-if="percentLoading.is_use"
          style="position: absolute; top: 20px"
        >
          {{ percentLoading.percent }}%
        </span>
        <h2 class="mt-5">{{ $t("waitingLoad") }}...</h2>
      </div>
    </v-overlay>

    <ModalConsent />
    <ModalNps />
  </v-app>
</template>

<script>
import Axios from "@/config/customer-service";
import ModalConsent from "@/views/Customer/ModalConsent.vue";
import ModalNps from "@/views/Customer/ModalNps.vue";
import { mapState } from "vuex";
import FallingSnowTheme from "@/components/theme/falling-snow-sway.vue";
import FallingHeartTheme from "@/components/theme/falling-heart.vue";
import moment from "moment";
import "moment/locale/th";
import "moment/locale/ja";
import "moment/locale/id";
import "moment/locale/ko";

export default {
  name: "App",
  components: {
    ModalConsent,
    ModalNps,
    FallingSnowTheme,
    FallingHeartTheme,
  },
  data: () => ({
    zIndex: 205,
    isLoading: false,
    percentLoading: {
      is_use: false,
      percent: 0,
    },
    site_themes: [],
    in_process: {
      is_use_line: false,
    },

    selectedFont: null,
  }),
  provide() {
    return {
      isAppLoading: async (open, time) => {
        return new Promise((resolve) => {
          const _time = time || 0;
          setTimeout(() => {
            this.isLoading = open;
            if (!open) {
              this.percentLoading.is_use = false;
              this.percentLoading.percent = 0;
            }
            resolve(true);
          }, _time);
        });
      },
      isAppLoadingPercent: async (is_use, percent) => {
        const onSleep = (msec) => {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve();
            }, msec || 500);
          });
        };
        this.percentLoading.is_use = is_use || false;
        const new_percent = percent || 0;
        const old_percent = this.percentLoading.percent;
        const diff = new_percent - old_percent;
        if (diff >= 0) {
          for (let i = 0; i < diff; i++) {
            const cur_percent = old_percent + i + 1;
            this.percentLoading.percent = cur_percent;
            await onSleep(2);
          }
        } else {
          this.percentLoading.percent = 0;
        }
      },
    };
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer", "language"]),
    overlayLoading: {
      set(value) {
        this.$store.commit("defaultSystem/SET_LOADING", value);
      },
      get() {
        return this.$store.getters["defaultSystem/getLoading"];
      },
    },
  },
  mounted() {},
  methods: {
    logoutAndClear() {
      Axios.post("logout")
        .then(() => {
          //
        })
        .catch((err) => {
          console.log("error:logoutAndClear", err);
        })
        .finally(() => {
          localStorage.clear();

          setTimeout(() => {
            location.reload();
          }, 500);
        });
    },
    async checkSiteLineLogin() {
      if (!this.in_process.is_use_line) {
        this.in_process.is_use_line = true;
        const dataSite = this.site;
        const id = this.customer?.id;
        const line_id = this.customer?.line_id;
        const is_use_line = dataSite?.is_use_line == "Y" ? true : false;
        const is_use_phone = dataSite?.is_use_phone == "Y" ? true : false;
        const is_use_google = dataSite?.is_use_google == "Y" ? true : false;
        const check_is_use_line_only =
          is_use_line && !is_use_phone && !is_use_google;
        if (check_is_use_line_only && id && !line_id) {
          this.$swal
            .fire({
              icon: "error",
              text: this.$t("error.sessionTimeout"),
              showConfirmButton: false,
            })
            .then(() => {
              this.in_process.is_use_line = false;
              this.logoutAndClear();
            });
        } else {
          this.in_process.is_use_line = false;
        }
      }
    },
  },
  watch: {
    site: {
      handler() {
        this.site_themes = this.site?.site_themes || [];
      },
      deep: true,
      immediate: true,
    },
    "$route.name": {
      handler() {
        if (this.$route.name?.startsWith("microsite-")) {
          moment.locale("en");
        } else {
          this.checkSiteLineLogin();
        }
      },
      deep: true,
      immediate: true,
    },
    language: {
      handler() {
        let _language = this.language;
        if (_language == "cn") {
          _language = "zh-cn";
        } else if (_language == "kr") {
          _language = "ko";
        }
        moment.locale(_language);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
@import url("./assets/styles/ql-editor.css");
@import url("https://fonts.googleapis.com/css2?family=Athiti:wght@400;500;600&display=swap");

.main {
  max-height: 2000px;
}
.menu-text {
  /* position: absolute; */
  z-index: 30;
}
.hamberger-menu {
  z-index: 40;
}
.display-coin {
  position: absolute;
  z-index: 50;
}
.v-list--two-line .v-list-item,
.v-list-item--two-line {
  min-height: 100px;
}
</style>
<style>
.v-input--selection-controls .v-input__slot > .v-label,
.v-input--selection-controls .v-radio > .v-label {
  color: rgba(0, 0, 0, 0.6) !important;
}
</style>
